import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import {
  lucideBookOpenText,
  lucideChartColumn,
  lucideInfo,
  lucideListChecks,
  lucideSettings,
} from "@ng-icons/lucide";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styles: ``,
  imports: [TranslatePipe, RouterModule, NgIconComponent],
  providers: [
    provideIcons({
      lucideChartColumn,
      lucideBookOpenText,
      lucideListChecks,
      lucideSettings,
      lucideInfo,
    }),
  ],
})
export class MenuComponent {}
